import React, { useEffect, useState } from 'react'
import ThisMixr from 'srcReact/components/Widgets/ThisMixr'
import GetToMeet from 'srcReact/components/Widgets/GetToMeet'
import RandomItems from 'srcReact/components/Widgets/RandomItems'
import { useTranslation } from 'react-i18next'
import FileNavigationPopup from 'srcReact/components/common2/FileNavigationPopup'
import LightProfileModal from 'srcReact/components/common2/LightProfileModal'

function Widgets({
  mixrId,
  isMixrNotOver,
  widgets,
  latitude,
  longitude,
  isMixrOver,
  isStaffMember,
  loggedInUser,
  handleAddToCalendar,
  handleShowMoreUsers,
  handleShowMoreMedia,
  handleAddCoorganizer,
  handleRemoveCoorganizer
}) {
  const [widgetInfo, setWidgetInfo] = useState(null)
  const [media, setMedia] = useState(null)
  const [participants, setParticipants] = useState(null)
  const [getToMeet, setGetToMeet] = useState(null)
  const [isImageOpen, setIsImageOpen] = useState(false)
  const [image, setImage] = useState(null)

  const [modalData, setModalData] = useState({
    isShowUserModal: false,
    selectedModalUser: {},
    selectedModalUserIndex: 0
  })

  const { t } = useTranslation()
  useEffect(() => {
    if (widgets) {
      setWidgetInfo(widgets.info)
      setMedia(widgets.media)
      setParticipants(widgets.participants)
      setGetToMeet(widgets.get_to_meet)
    }
  }, [mixrId, widgets])

  const showImageModal = (img) => {
    setIsImageOpen(true)
    setImage(img)
  }

  const closeImageModal = () => {
    setIsImageOpen(false)
  }

  const hideUserModal = () => {
    setModalData({
      ...modalData,
      isShowUserModal: false
    })
  }

  const showUserModal = (user, userIndex, users) => {
    setModalData({
      isShowUserModal: true,
      selectedModalUser: user,
      selectedModalUserIndex: userIndex
    })
  }

  const getOptionsBasedOnRole = () => {
    let options = []
    if (loggedInUser.id !== modalData.selectedModalUser.id && !isMixrOver) {
      if (isStaffMember) {
        if (modalData.selectedModalUser.role === 'co-organizer') {
          options.push({
            text: t('mixrHome.members.removeRole'),
            onClick: () => handleRemoveCoorganizer(modalData.selectedModalUser.id)
          })
        } else if (modalData.selectedModalUser.role === 'participant') {
          options.push({
            text: t('mixrHome.members.addCoOrganizer'),
            onClick: () => handleAddCoorganizer(modalData.selectedModalUser.id)
          })
        }
      }
    }
    return options
  }

  const navigate = (direction) => {
    let nextUserIndex =
      direction === 'next' ? modalData.selectedModalUserIndex + 1 : modalData.selectedModalUserIndex - 1
    if (nextUserIndex > getToMeet.length - 1) {
      nextUserIndex = 0
    } else if (nextUserIndex < 0) {
      nextUserIndex = getToMeet.length - 1
    }
    setModalData({
      ...modalData,
      selectedModalUserIndex: nextUserIndex,
      selectedModalUser: getToMeet[nextUserIndex]
    })
  }

  return (
    <React.Fragment>
      {widgetInfo && (
        <ThisMixr
          isMixrNotOver={isMixrNotOver}
          startDateTime={widgetInfo.local_start_at}
          endDateTime={widgetInfo.local_end_at}
          duration={widgetInfo.duration}
          address={widgetInfo.address?.trim()}
          timezone={widgetInfo.timezone}
          longitude={longitude}
          latitude={latitude}
          joinLink={widgetInfo.join_in_link}
          handleAddToCalendar={handleAddToCalendar}
        />
      )}
      {getToMeet && getToMeet.length > 0 && <GetToMeet participants={getToMeet} showUserModal={showUserModal} />}
      {participants && participants.participants_count > 0 && (
        <RandomItems
          type='user'
          subTitle={t('myhome.mymixrs.participants').toUpperCase()}
          totalCount={participants.participants_count}
          items={participants.participants_random_order}
          imageName='user'
          handleShowMore={handleShowMoreUsers}
          showUserModal={showUserModal}
        />
      )}

      {media && media.total_count > 0 && (
        <RandomItems
          type='media'
          subTitle={t('widgets.randomMedia.title').toUpperCase()}
          totalCount={media.total_count}
          items={media.recent_media}
          imageName='media'
          handleShowMore={handleShowMoreMedia}
          showImageModal={showImageModal}
        />
      )}
      {isImageOpen && image && (
        <FileNavigationPopup
          isOpen={isImageOpen}
          file={image}
          fileIndex={-1}
          files={null}
          closeModal={closeImageModal}
          enableDeleteFile={false}
          plain={true}
        />
      )}
      {modalData.isShowUserModal && (
        <LightProfileModal
          userIdwithRole={modalData.selectedModalUser.id}
          show={modalData.isShowUserModal}
          userswithRole={modalData.selectedModalUserIndex ? getToMeet : null}
          userIndexWithRole={modalData.selectedModalUserIndex}
          roleManagementOptions={getOptionsBasedOnRole()}
          closeModalWithRole={hideUserModal}
          navigateWithRole={navigate}
        />
      )}
    </React.Fragment>
  )
}

export default Widgets
